import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const services = [
    { name: 'Tax Preparation', id: 'tax' },
    { name: 'Bookkeeping', id: 'bookkeeping' },
    { name: 'Payroll Services', id: 'payroll' },
    { name: 'Financial Planning', id: 'retirement' },
    { name: 'Business Valuation', id: 'valuation' },
    { name: 'Audit Assistance', id: 'assurance' },
  ];

  return (
    <footer className="footer">
      <div className="footer__wave">
        <svg viewBox="0 0 1440 100" preserveAspectRatio="none">
          <path d="M0,40 C360,100 720,0 1080,60 C1260,90 1380,50 1440,40 L1440,100 L0,100 Z" fill="currentColor" />
        </svg>
      </div>

      <div className="footer__body">
        <div className="container">
          <div className="footer__grid">
            {/* Brand Column */}
            <div className="footer__brand">
              <Link to="/" className="footer__logo">
                <img src="/images/logo.svg" alt="GFS Logo" />
                <div>
                  <span className="footer__logo-name">Gelejian</span>
                  <span className="footer__logo-tag">Financial Services</span>
                </div>
              </Link>
              <p className="footer__desc">
                Providing quality, personalized financial guidance to individuals and businesses in Southern California and beyond for over 30 years.
              </p>
            </div>

            {/* Quick Links */}
            <div className="footer__col">
              <h4 className="footer__heading">Quick Links</h4>
              <ul className="footer__list">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>

            {/* Services */}
            <div className="footer__col">
              <h4 className="footer__heading">Services</h4>
              <ul className="footer__list">
                {services.map((s) => (
                  <li key={s.id}><Link to={`/services#${s.id}`}>{s.name}</Link></li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div className="footer__col">
              <h4 className="footer__heading">Contact Us</h4>
              <ul className="footer__contact">
                <li>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                  <span>20121 Ventura Blvd Ste 310<br />Woodland Hills, CA 91364</span>
                </li>
                <li>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
                  <a href="tel:+18183430080">(818) 343-0080</a>
                </li>
                <li>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                  <a href="mailto:vahan@gelejianfs.com">vahan@gelejianfs.com</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="container">
          <p>&copy; {currentYear} Gelejian Financial Services. All rights reserved.</p>
          <a
            href="https://softangeles.com"
            target="_blank"
            rel="noopener noreferrer"
            className="footer__credit"
            style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', opacity: 0.9, fontSize: '15px', fontWeight: 500, textDecoration: 'none', color: '#ffffff' }}
          >
            <span>Powered by</span>
            <img src="https://softangeles.com/logo-wide.png" alt="SoftAngeles" style={{ height: '30px', width: 'auto' }} />
          </a>
        </div>
      </div>
    </footer>
  );
}
